module.exports = __webpack_public_path__ + "static/media/colour.d50e8b89.svg";